import { TimeSeriesColors } from "@intelligems/ig-graphs";
import { IgChip } from "@intelligems/ig-theme";
import { LineData } from "@intelligems/ig-types";
import { hexToRgbA } from "@intelligems/ig-utils";
import { Stack } from "@mui/material";
import { AnalyticsLegendIcon } from "@src/images/Icons/AnalyticsLegendIcon";
import { StrippedCircle } from "@src/images/Icons/StrippedCircleIcon";

type InteractiveChartLegendProps = {
  focusGroups: string[];
  onLegendClick: (dataKey: string) => void;
  disabled?: boolean;
  lines: LineData[];
  colors?: string[];
};
export const InteractiveChartLegend = ({
  focusGroups,
  onLegendClick,
  disabled,
  lines,
  colors = TimeSeriesColors,
}: InteractiveChartLegendProps) => {
  return (
    <Stack justifyContent="center" direction={"row"} gap={2} flexWrap={"wrap"}>
      {lines.map((line, index) => {
        const color = line.color ?? colors[index];

        return (
          <IgChip
            disabled={disabled}
            onClick={() => {
              onLegendClick(line?.id || "");
            }}
            key={index}
            variant={"outlined"}
            icon={
              line.isDotted ? (
                <StrippedCircle
                  fill={color}
                  width="10px"
                  height="10px"
                  style={{
                    paddingLeft: "4px",
                  }}
                />
              ) : (
                <AnalyticsLegendIcon
                  fill={color}
                  sx={{
                    width: "10px",
                    height: "10px",
                    paddingLeft: "4px",
                  }}
                />
              )
            }
            sx={{
              fontWeight: 600,
              borderColor: focusGroups.includes(line?.id || "")
                ? "transparent"
                : color,
              backgroundColor: focusGroups.includes(line?.id || "")
                ? "transparent"
                : hexToRgbA(color, 0.1),
              borderStyle: line.isDotted ? "dashed" : "solid",
              minWidth: "50px",
              fontSize: "12px",
              height: "30px",
            }}
            label={line?.name || ""}
          />
        );
      })}
    </Stack>
  );
};
